import {
	GET_ADMIN_ASSIGNEES,
	FETCH_ADMIN_ASSIGNEE,
	ADD_ADMIN_ASSIGNEE,
	EDIT_ADMIN_ASSIGNEE,
	DELETE_ADMIN_ASSIGNEE,
} from "constants/actions";

const initialState = {
	assignees: [],
	pending: false,
};

export default function ActionAssignee(state = initialState, action) {
	switch (action.type) {
		case GET_ADMIN_ASSIGNEES:
			return {
				...state,
				assignees: action.payload,
				pending: false,
			};

		case FETCH_ADMIN_ASSIGNEE:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case ADD_ADMIN_ASSIGNEE:
		case EDIT_ADMIN_ASSIGNEE:
			if (state.assignees && Array.isArray(state.assignees)) {
				const exists = state.assignees.find((a) => a.id === action.payload.id);
				const assignees = exists
					? state.assignees.map((a) => (a.id === action.payload.id ? action.payload : a))
					: [...state.assignees, action.payload];

				return {
					...state,
					assignees,
					[action.payload.id]: action.payload,
					pending: false,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case DELETE_ADMIN_ASSIGNEE:
			return {
				...state,
				assignees: (state.assignees || []).filter((row) => row.id !== action.payload),
				pending: false,
			};

		default:
			return state;
	}
}

